<google-map
    width="100vw"
    height="100vh"
    [center]="center"
    [zoom]="zoom"
    [options]="options"
    (mapDragend)="dragAction()"
>

@if (type == "ALL" || type == "MRT") {
    @for (mrtMarker of mrtMarkers; track $index) {
        <map-advanced-marker (mapClick)="showDetail('MRT',mrtMarker.name,mrtMarker.stationId)" [position]="mrtMarker.position" [options]="createMarkerOptions('mrt')"/>
    }
}

@if (type == "ALL" || type == "THSR") {
    @for (thsrMarker of thsrcMarkers; track $index) {
        <map-advanced-marker (mapClick)="showDetail('THSR',thsrMarker.name,thsrMarker.stationId)" [position]="thsrMarker.position" [options]="createMarkerOptions('thsr')"/>
    }
}

@if (type == "ALL" || type == "TRA") {
    @for (traMarker of traMarkers; track $index) {
        <map-advanced-marker (mapClick)="showDetail('TRA',traMarker.name,traMarker.stationId)" [position]="traMarker.position" [options]="createMarkerOptions('tra')"/>
    }
}

@if (type == "ALL" || type == "BUS") {
    @for (busMarker of busMarkers; track $index) {
        @if (getDistanceFromLatLonInKm(busMarker.position.lat,busMarker.position.lng)) {
        <map-advanced-marker (mapClick)="showDetail('BUS',busMarker.name,busMarker.stationId)" [position]="busMarker.position" [options]="createMarkerOptions('bus')"/>
        }
    }
}

@if (type == "ALL" || type == "NHPT") {
    @for (nhptMarker of nhptMarkers; track $index) {
        @if (getDistanceFromLatLonInKm(nhptMarker.position.lat,nhptMarker.position.lng)) {
        <map-advanced-marker (mapClick)="showDetail('NHPT',nhptMarker.name,nhptMarker.stationId)" [position]="nhptMarker.position" [options]="createMarkerOptions('nhpt')"/>
        }
    }
}

@if (type == "ALL" || type == "BIKE") {
    @for (bikeMarker of bikeMarkers; track $index) {
        @if (getDistanceFromLatLonInKm(bikeMarker.position.lat,bikeMarker.position.lng)) {
        <map-advanced-marker (mapClick)="showDetail('BIKE',bikeMarker.name,bikeMarker.stationId)" [position]="bikeMarker.position" [options]="createMarkerOptions('ibike')"/>
        }
    }
}


<map-advanced-marker [position]="center"  [options]="createMarkerOptions('point')" />
    <map-circle [center]="mapCenter" [radius]="radius" [options]="circleOptions" />
</google-map>
